import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <p><span className="subtiltereg">Strengths Identification and Matching Process</span>
                                            </p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/engage_others.png')}
                                                    alt=""/>

                                            </div>

                                            <div className="border_subtitle">Stage One</div>
                                            <p>Consider the individuals in your team or work group and identify
                                                the strengths of each.</p>

                                            <table className="ilead_v_sport tablesrink people_active2"
                                                   border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <td className="subheading2bg roundBorder lightBG1Dark"
                                                        align="left" valign="top" width="15%"><p><span
                                                        className="subtiltereg">1.1 Observe</span></p>
                                                    </td>
                                                    <td className="lightgreen roundBorder1" align="left"
                                                        valign="top" width="85%">
                                                        <div className="uiheading">
                                                            <ul className="greenbullet-list greenbullet-listspacing">
                                                                <li> What is it that energises this person?</li>
                                                                <li>What is it that makes this person feel under
                                                                    pressure?
                                                                </li>
                                                                <li>When have you seen this person absorbed in a
                                                                    task?
                                                                </li>
                                                                <li>How do others most commonly describe this
                                                                    person?
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className="subheading2bg lightBG1Dark" align="left"
                                                        valign="top" width="15%"><p><span
                                                        className="subtiltereg">1.2 Theorise</span></p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="85%">
                                                        <div className="uiheading"><p>Which of these team roles
                                                            are represented in your team<a
                                                                className="superscripttext"
                                                                href="further_info.php?course=300"><sup>2</sup></a>:
                                                        </p>
                                                            <ul className="greenbullet-list uiheading">
                                                                <li><p><span
                                                                    className="subtiltereg"> Coordinator </span>–
                                                                    clarifies goals, promotes decision making
                                                                </p></li>
                                                                <li><p><span
                                                                    className="subtiltereg">Shaper </span>–
                                                                    challenging, dynamic, drives to overcome
                                                                    obstacles</p></li>
                                                                <li><p><span
                                                                    className="subtiltereg">Plant </span>–
                                                                    creative, imaginative, solves difficult
                                                                    problems</p></li>
                                                                <li><p><span
                                                                    className="subtiltereg">Monitor-Evaluator</span> –
                                                                    strategic, sees all options, judges
                                                                    accurately</p></li>
                                                                <li><p><span
                                                                    className="subtiltereg">Implementer </span>–
                                                                    disciplined, reliable, turns ideas into
                                                                    practical actions</p></li>
                                                                <li><p><span className="subtiltereg">Resource Investigator </span>–
                                                                    extrovert, explores opportunities, develops
                                                                    contacts</p></li>
                                                                <li><p><span
                                                                    className="subtiltereg">Team Worker </span>–
                                                                    co-operative, perceptive, diplomatic,
                                                                    listens and builds</p></li>
                                                                <li><p><span
                                                                    className="subtiltereg">Specialist </span>–
                                                                    single-minded, dedicated, provides knowledge
                                                                    and skills in
                                                                    rare supply</p></li>
                                                                <li><p><span
                                                                    className="subtiltereg">Completer Finisher </span>–
                                                                    conscientious, searches out errors, delivers
                                                                    on time.</p></li>

                                                            </ul>
                                                        </div>
                                                        <div className="paraspace"><p>Consider this person’s
                                                            preferences, e.g. how do they make decisions? How do
                                                            they gather information? How do they organise their
                                                            ‘outer world?’ Do they get
                                                            their energy from within or from others?</p></div>


                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className="subheading2bg lightBG1Dark" align="left"
                                                        valign="top" width="15%"><p><span
                                                        className="subtiltereg">1.3 Ask</span></p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="85%">
                                                        <ul className="greenbullet-list uiheading greenbullet-listspacing">
                                                            <li><p>Ask them to describe what most energises,
                                                                absorbs and motivates them.</p></li>
                                                            <li><p>Ask them about the work they’ve been doing in
                                                                the last month and notice which
                                                                roles they talk about excitedly and fluently and
                                                                those they have little to say about.</p></li>
                                                            <li><p>Ask them when they’ve felt under
                                                                pressure.</p></li>
                                                            <li><p>Ask them when they’ve felt comfortable – and
                                                                when challenged. Notice which
                                                                challenges have been enjoyable and which they
                                                                found stressful.</p></li>
                                                        </ul>
                                                    </td>

                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}